export const companyCommand = {
  fortnoxConfig: 'fortnoxConfig',
  vismaConfig: 'vismaConfig',
  vismaControlEdgeConfig: 'vismaControlEdgeConfig',
  export: 'export',
  closeAccountingPeriod: 'closeAccountingPeriod',
  bulkSystemSettings: 'bulkSystemSettings',
};
